import { render, staticRenderFns } from "./addAuthorize.vue?vue&type=template&id=6adf59fd&scoped=true&"
import script from "./addAuthorize.vue?vue&type=script&lang=js&"
export * from "./addAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./addAuthorize.vue?vue&type=style&index=0&id=6adf59fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf59fd",
  null
  
)

export default component.exports